import React from "react";
import { PlanOfCareItemId, RequiredDutySheetTask } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { List } from "../../../utils/List";
import { Center } from "../../Center";
import { AppList } from "../../Generic/AppList";
import { If } from "../../Generic/If";
import NotesText from "../../Patient/components/NotesText";
import { SelectedDutyTasks } from "../useTimesheetForm";
import DutyTaskItem from "./DutyTaskItem";

interface DutyTasksListProps {
  duties: List<RequiredDutySheetTask>;
  isTaskItemDisabled?: boolean;
  selectedDutyTasks: SelectedDutyTasks;
  onChangeNotes: (taskId: PlanOfCareItemId, notes: string) => void;
  onCheck: (taskId: PlanOfCareItemId, isChecked: boolean) => void;
  onDisabledTaskItemClick?: () => void;
}

function DutyTasksList(props: DutyTasksListProps) {
  return (
    <AppList className="DutyTasksList">
      <If condition={props.duties.length() === 0}>
        <NotesText>
          <Center>{translate(STRINGS.THIS_VISIT_DOES_NOT_REQUIRE_ANY_TASKS_TO_BE_DONE)}</Center>
        </NotesText>
      </If>
      {props.duties.map((task) => (
        <DutyTaskItem
          key={`task-${task.id}`}
          duty={task}
          notes={props.selectedDutyTasks.get(task.id)?.notes ?? null}
          isChecked={props.selectedDutyTasks.has(task.id)}
          isRequired={task.isRequired}
          isTaskItemDisabled={props.isTaskItemDisabled}
          onChangeNotes={props.onChangeNotes}
          onCheck={props.onCheck}
          onDisabledTaskItemClick={props.onDisabledTaskItemClick}
        />
      ))}
    </AppList>
  );
}

export default DutyTasksList;
